/* ============================================================
   Thema lesen, setzen, umschalten.

   Wie /opt/fragenbuero/frontend/src/lib/theme.ts, mit zwei Aenderungen
   (T23, understand/design.json Schnipsel 10): THEME_STANDARD ist "light",
   und readTheme() faellt auf das SYSTEM zurueck, solange niemand gewaehlt
   hat. Der Schluessel `zp.theme` muss mit public/theme.js uebereinstimmen —
   dort steht derselbe Name, damit das Thema schon VOR dem ersten Anstrich
   sitzt und beim Laden nichts aufblitzt.

   Das BLATT ist von all dem nicht betroffen: --paper/--petrol/--chart-*
   stehen in tokens.css nur EINMAL, ohne Gegenstueck in html.dark (E7/T23).
   Im dunklen Thema liegt ein helles Blatt auf dunklem Tisch.
   ============================================================ */
import { load, save } from "./storage";

export type Theme = "dark" | "light";

/** Schluessel in localStorage: `zp.theme`. MUSS mit public/theme.js uebereinstimmen. */
export const THEME_KEY = "theme";

export function systemTheme(): Theme {
  try {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  } catch {
    return "light";
  }
}

export const THEME_STANDARD: Theme = "light";

export function readTheme(): Theme {
  const t = load<Theme | null>(THEME_KEY, null);
  if (t === "light" || t === "dark") return t;
  return systemTheme();
}

/** Setzt das Thema am Dokument — und NUR dort; gespeichert wird in setTheme(). */
export function applyTheme(theme: Theme): void {
  const el = document.documentElement;
  el.classList.toggle("dark", theme === "dark");
  el.classList.toggle("light", theme !== "dark");
  // Werte sind --bg aus tokens.css, als Literal: getComputedStyle laese hier
  // noch den alten Wert.
  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute("content", theme === "dark" ? "#121a1b" : "#efebe3");
}

export function setTheme(theme: Theme): void {
  applyTheme(theme);
  save(THEME_KEY, theme);
}

export function toggleTheme(): Theme {
  const next: Theme = readTheme() === "dark" ? "light" : "dark";
  setTheme(next);
  return next;
}
